import { render, staticRenderFns } from "./ProductDemo.vue?vue&type=template&id=705d77ae&scoped=true&"
import script from "./ProductDemo.vue?vue&type=script&lang=js&"
export * from "./ProductDemo.vue?vue&type=script&lang=js&"
import style0 from "./ProductDemo.vue?vue&type=style&index=0&id=705d77ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705d77ae",
  null
  
)

export default component.exports